var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgG05(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.944,
    height: 80.948,
    viewBox: "0 0 80.944 80.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.944,
    height: 80.948,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80.944,
    height: 80.948,
    fill: "#ff3b21"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.907,11.952A2.478,2.478,0,0,0,10.6,13.083h-.024V9.015H15.29V6.776H8.069v9.2h2.5V15.61c0-.963.434-1.492,1.2-1.492.843,0,1.181.578,1.181,1.469v3.948C12.956,20.4,12.643,21,11.8,21c-.939,0-1.275-.626-1.275-1.588V17.369H8.019v1.853c0,2.479.988,4.068,3.781,4.068,2.768,0,3.9-1.468,3.9-3.731v-4c0-2.576-1.323-3.611-2.792-3.611",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.332,58.74a9.7,9.7,0,1,1,9.7-9.7,9.709,9.709,0,0,1-9.7,9.7M58.958,30.63H48.9a.129.129,0,0,0-.128.128V34.1a.129.129,0,0,0,.128.129H52.9l-4.448,4.449A13.171,13.171,0,1,0,38.631,62.1v3.852H34.663a.127.127,0,0,0-.129.128v3.583a.127.127,0,0,0,.129.128h3.968v3.791a.127.127,0,0,0,.128.127h3.582a.128.128,0,0,0,.129-.127V69.795h3.968a.128.128,0,0,0,.128-.128V66.084a.128.128,0,0,0-.128-.128H42.47V62.042A13.164,13.164,0,0,0,51.1,41.463l4.385-4.386v3.742a.129.129,0,0,0,.13.128h3.342a.13.13,0,0,0,.131-.128V30.758a.13.13,0,0,0-.131-.128",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.256,45.06H34.492a.122.122,0,0,0-.127.115v2.848a.121.121,0,0,0,.127.116H46.256a.122.122,0,0,0,.13-.116V45.175a.123.123,0,0,0-.13-.115",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.256,50.145H34.492a.124.124,0,0,0-.127.119v2.847a.121.121,0,0,0,.127.115H46.256a.122.122,0,0,0,.13-.115V50.264a.125.125,0,0,0-.13-.119",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.115,16.48h2.654v.907H24.227V19.28h1.1v.9h-1.1v2.01h1.542v.907H23.115Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7,21.621V18.012c0-.4-.175-.683-.575-.683s-.566.283-.566.683v3.609c0,.39.176.683.566.683s.575-.293.575-.683m-.985,1.922v-.449a1.521,1.521,0,0,1-1.268-1.707v-3.2a1.685,1.685,0,1,1,3.365,0v3.2A1.588,1.588,0,0,1,29,22.948l.819.156v.829Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.77,16.48v5c0,1.025-.439,1.688-1.57,1.688a1.493,1.493,0,0,1-1.659-1.688v-5h1.112v5.112c0,.39.156.653.547.653s.546-.263.546-.653V16.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.722,21h.888l-.439-2.654h-.01Zm-1.4,2.1,1.249-6.614h1.268L38.1,23.094H36.961l-.2-1.21h-1.18l-.195,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.65,16.48h1.112v5.707h1.327v.907H38.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.112,
    height: 6.614,
    transform: "translate(41.684 16.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.392,16.48h2.956v.907h-.917v5.707H44.309V17.387h-.917Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.109,20.577v2.517H48V20.577l-1.239-4.1h1.161l.673,2.507h.01l.673-2.507h1.064Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.793,9.859h1.581V13.39h-.8v-.721a1,1,0,0,1-1.064.8c-.956,0-1.4-.76-1.4-1.785v-3.2A1.567,1.567,0,0,1,24.783,6.7c1.23,0,1.591.683,1.591,1.659v.585H25.359V8.269c0-.41-.156-.644-.556-.644s-.576.283-.576.683v3.551c0,.4.166.683.547.683.36,0,.546-.2.546-.634V10.737h-.527Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.106,6.776H29.76v.907H28.218V9.576h1.1v.9h-1.1v2.01H29.76v.907H27.106Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.392,9.234v4.156h-.937V6.777h1.093l1.2,3.794V6.777h.927v6.614H32.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.988,12.483c.458,0,.634-.273.634-.673V8.347a.579.579,0,0,0-.634-.663h-.469v4.8Zm1.746-3.931v3.063c0,1.015-.419,1.776-1.61,1.776H34.407V6.776h1.717c1.191,0,1.61.752,1.61,1.776",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.477,6.776h2.654v.907H39.589V9.576h1.1v.9h-1.1v2.01h1.542v.907H38.477Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.926,7.683V9.741H43.3a.481.481,0,0,0,.546-.546V8.22c0-.361-.165-.537-.546-.537Zm0,2.673V13.39H41.814V6.776h1.619c1.122,0,1.532.556,1.532,1.483v.848c0,.713-.253,1.132-.888,1.278l1.064,3.005H43.97Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG05);
export default __webpack_public_path__ + "static/media/G05.11f239a744c3f053d657c8f736dd6f14.svg";
export { ForwardRef as ReactComponent };